module.exports = __webpack_public_path__ + "img/slide-4.68a4c20a.jpg";